import React, { useEffect, useRef } from 'react';
import EventSystem from './EventSystem';
import './css/clockModule.css';

export default function FlashScreen() {
    const overlayRef = useRef(null);
    const timeridRef = useRef(null);

    useEffect(() => {
        function flash(data) {
            const node = overlayRef.current;
            if (!node) return;
            if (data.action === 'start') {
                node.classList.add('laser');
                if (timeridRef.current) clearTimeout(timeridRef.current);
                if ('vibrate' in window.navigator) navigator.vibrate([200, 20, 20, 100, 200]);
                timeridRef.current = setTimeout(() => {
                    if (overlayRef.current) overlayRef.current.classList.remove('laser');
                }, 500);
            } else if (data.action === 'stop') {
                node.classList.remove('laser');
            }
        }
        EventSystem.subscribe('FlashScreen', flash);
        return () => EventSystem.unsubscribe('FlashScreen');
    }, []);

    return (
        <div
            ref={overlayRef}
            style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                pointerEvents: 'none',
                zIndex: 9999,
            }}
        />
    );
}
